var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"}},[_c('path',{attrs:{"d":"M6.3 4.88L1.7.3A1 1 0 10.3 1.71L4.9 6.3a1 1 0 010 1.42L.3 12.3a1 1 0 001.4 1.42l4.6-4.59a3 3 0 000-4.24z","fill":"#242424"}})])}
var staticRenderFns = []

export { render, staticRenderFns }